/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_Supadata_QuotaInputs */

const en_import_fail_supadata_quota = /** @type {(inputs: Import_Fail_Supadata_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Supadata plan is used up. Top it up at supadata.ai, then try again.`)
};

const de_import_fail_supadata_quota = /** @type {(inputs: Import_Fail_Supadata_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Supadata-Kontingent ist aufgebraucht. Lade es auf supadata.ai auf und versuch es dann noch einmal.`)
};

/**
* | output |
* | --- |
* | "Your Supadata plan is used up. Top it up at supadata.ai, then try again." |
*
* @param {Import_Fail_Supadata_QuotaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_supadata_quota = /** @type {((inputs?: Import_Fail_Supadata_QuotaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_Supadata_QuotaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_supadata_quota(inputs)
	return en_import_fail_supadata_quota(inputs)
});